import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { useCcStore } from '../../store/ccStore';
import { useTargetStore } from '../../store/targetStore';
import { geometryCentroid } from '../../lib/geo';
import { OP_BATTLE_META } from '../../types/domain';

function battleIcon(op: 'RAID' | 'AMBUSH' | 'CACHE_HUNT'): L.DivIcon {
  const m = OP_BATTLE_META[op];
  const uid = `b${Math.random().toString(36).slice(2)}`;
  return L.divIcon({
    className: 'battle-overlay',
    html: `
      <style>@keyframes ${uid}{0%{transform:scale(.5);opacity:.9}100%{transform:scale(1.6);opacity:0}}</style>
      <div style="position:relative;width:64px;height:64px;">
        <div style="position:absolute;inset:0;border-radius:50%;border:3px solid ${m.color};
          animation:${uid} ${m.pulseMs}ms cubic-bezier(0,0,0.2,1) infinite;"></div>
        <div style="position:absolute;inset:12px;border-radius:50%;background:${m.color}33;border:2px solid ${m.color};
          display:flex;align-items:center;justify-content:center;font-size:22px;">${m.emoji}</div>
        <div style="position:absolute;left:50%;top:66px;transform:translateX(-50%);white-space:nowrap;
          font:700 10px/1 'Share Tech Mono',monospace;color:${m.color};text-shadow:0 1px 2px #000;">${m.label}</div>
      </div>`,
    iconSize: [64, 64],
    iconAnchor: [32, 32],
  });
}

// Animated overlay at each target under live execution (docs/14 §3.7).
export default function BattleOverlay() {
  const activeExecutions = useCcStore((s) => s.activeExecutions);
  const { targets } = useTargetStore();

  return (
    <>
      {Object.values(activeExecutions).map((ex) => {
        const target = targets.find((t) => t.id === ex.targetId);
        if (!target) return null;
        const c = geometryCentroid(target);
        if (!c) return null;
        return (
          <Marker key={ex.targetId} position={[c.lat, c.lon]} icon={battleIcon(ex.operationType)} zIndexOffset={2000} interactive={false} />
        );
      })}
    </>
  );
}
